/* VAEL Maison — storefront behaviours, part 2 */
(() => {
  'use strict';
  const { CFG, $, $$, store, once, toast, initReveal, initHero, initCarousels, initTabs, wl, wlToggle, syncWishlistUI, fetchCard, renderHandles, initWishlistPage, addToCart } = window.__VAEL;

  /* ---------------- membership box ---------------- */
  function initMember() {
    const tab = $('[data-member-tab]'), panel = $('[data-member-panel]');
    if (!tab || !panel) return;
    const state = store.get('vael:member', null);
    const posted = /customer_posted=true/.test(location.search) || panel.querySelector('.vael-form-success');
    const open = () => { panel.classList.add('is-open'); tab.classList.remove('is-visible'); };
    const close = () => { panel.classList.remove('is-open'); if (store.get('vael:member', null) !== 'joined') tab.classList.add('is-visible'); };
    $('[data-member-open]', tab).addEventListener('click', open);
    $('[data-member-dismiss]', tab).addEventListener('click', () => { tab.classList.remove('is-visible'); store.set('vael:member', 'dismissed'); });
    $('[data-member-close]', panel).addEventListener('click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && panel.classList.contains('is-open')) close(); });
    if (posted) { store.set('vael:member', 'joined'); tab.hidden = false; open(); return; }
    if (state) return;
    tab.hidden = false;
    setTimeout(() => tab.classList.add('is-visible'), (CFG.memberDelay || 6) * 1000);
  }

  /* ---------------- modals (size guide) ---------------- */
  function openModal(name) {
    const m = $('[data-vael-modal="' + name + '"]');
    if (!m) return;
    m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const c = $('.vael-modal__close', m); c && c.focus();
  }
  function closeModal(m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-open-modal]');
    if (o) { e.preventDefault(); openModal(o.dataset.openModal); return; }
    const c = e.target.closest('[data-modal-close]');
    if (c) { const m = c.closest('.vael-modal'); m && closeModal(m); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') $$('.vael-modal.is-open').forEach(closeModal); });
  function initSizeTables(root = document) {
    $$('[data-size-table]', root).forEach((t) => {
      if (!once(t, 'vs')) return;
      const cells = $$('td[data-cm]', t);
      const fmt = (unit) => cells.forEach((td) => {
        td.textContent = unit === 'cm' ? td.dataset.cm : td.dataset.cm.split('–').map((n) => (parseFloat(n) / 2.54).toFixed(1)).join('–');
      });
      fmt('cm');
      const toggle = t.previousElementSibling;
      toggle && $$('[data-unit]', toggle).forEach((b) => b.addEventListener('click', () => {
        $$('[data-unit]', toggle).forEach((x) => x.classList.toggle('is-active', x === b)); fmt(b.dataset.unit);
      }));
    });
  }

  /* ---------------- menu tags ---------------- */
  function initMenuTags() {
    const raw = (CFG.menuTags || '').trim();
    if (!raw) return;
    const map = {};
    raw.split(/\n+/).forEach((line) => { const [k, v] = line.split(':'); if (k && v) map[k.trim().toLocaleLowerCase('tr')] = v.trim(); });
    $$('#header-component a, .header__drawer a, header-drawer a').forEach((a) => {
      if (a.querySelector('.vael-menu-tag')) return;
      const label = (a.textContent || '').trim().toLocaleLowerCase('tr');
      const tag = map[label];
      if (!tag) return;
      const target = a.querySelector('span') || a;
      const s = document.createElement('span'); s.className = 'vael-menu-tag'; s.textContent = tag;
      target.appendChild(s);
    });
  }

  /* ---------------- shop the look ---------------- */
  function initLooks(root = document) {
    $$('[data-vael-look]', root).forEach((look) => {
      if (!once(look, 'vl')) return;
      const spots = $$('[data-hotspot]', look), items = $$('[data-look-item]', look);
      const activate = (n) => {
        spots.forEach((s) => s.classList.toggle('is-active', s.dataset.hotspot === n));
        items.forEach((it) => it.classList.toggle('is-active', it.dataset.lookItem === n));
      };
      spots.forEach((s) => s.addEventListener('click', () => {
        activate(s.dataset.hotspot);
        const it = items.find((x) => x.dataset.lookItem === s.dataset.hotspot);
        it && it.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }));
      items.forEach((it) => it.addEventListener('mouseenter', () => activate(it.dataset.lookItem)));
      const all = $('[data-look-add-all]', look);
      all && all.addEventListener('click', async () => {
        const ids = $$('[data-look-variant]', look).map((sel) => sel.value).filter(Boolean);
        if (!ids.length) return;
        all.classList.add('is-loading');
        const actions = window.Shopify && window.Shopify.actions;
        if (actions && actions.updateCart) {
          await actions.updateCart({ lines: ids.map((id) => ({ merchandiseId: String(id), quantity: 1 })) }, { event: { context: 'standard-action' } });
          actions.openCart && actions.openCart();
        } else {
          await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: ids.map((id) => ({ id: Number(id), quantity: 1 })) }) });
          location.href = '/cart';
        }
        all.classList.remove('is-loading');
      });
    });
  }

  /* ---------------- press ---------------- */
  function initPress(root = document) {
    $$('[data-vael-press]', root).forEach((p) => {
      if (!once(p, 'vp')) return;
      const q = $('[data-press-quote]', p), logos = $$('[data-quote]', p);
      if (!q || !logos.length) return;
      let i = 0;
      const show = (n) => { i = n; logos.forEach((l, k) => l.classList.toggle('is-active', k === n)); q.textContent = '“' + logos[n].dataset.quote + '”'; };
      logos.forEach((l, k) => l.addEventListener('click', () => show(k)));
      show(0);
      setInterval(() => { if (!document.hidden) show((i + 1) % logos.length); }, 5000);
    });
  }

  Object.assign(window.__VAEL, { initMember, openModal, closeModal, initSizeTables, initMenuTags, initLooks, initPress });
})();